<template>
  <b-modal :visible="modal" @hide="closeModal">
    <div slot="modal-title">
      {{ $t('bulkActions') }}
    </div>
    <b-container fluid>
      <b-row>
        <div class="col-12">
          <h5 class="error-title">
            {{ modalTitle }}
          </h5>
          <div class="error-description" v-html="modalDescription" />
        </div>
      </b-row>
      <b-row class="buttons-container text-center">
        <div class="col-12" style="margin-top: 10px;">
          <b-button
            class="cta-btn"
            variant="primary"
            size="lg"
            @click="handleCtaClick"
            :disabled="disableCta"
          >
            {{ ctaButtonText }}
          </b-button>
        </div>
        <div class="col-12" style="margin-top: 20px;">
          <a href="#" class="primary-text" @click.stop.prevent="closeModal">
            {{ $t('closeAndChange') }}
          </a>
        </div>
      </b-row>
    </b-container>
    <div slot="modal-footer" />
  </b-modal>
</template>

<script>
export default {
  name: 'ErrorModal',
  props: {
    modal: { type: Boolean, required: true },
    closeModal: { type: Function, required: true },
    errorType: { type: String, required: true },
    handleCtaClick: { type: Function, required: true },
    disableCta: { type: Boolean, default: false }
  },
  computed: {
    modalTitle () {
      switch (this.errorType) {
        case 'allocate':
          return this.$t('multipleSelectionAllocateErrorTitle')
        default:
          return this.$t('multipleSelectionOtherErrorTitle')
      }
    },
    modalDescription () {
      switch (this.errorType) {
        case 'allocate':
          return this.$t('multipleSelectionAllocateErrorDescription')
        default:
          return this.$t('multipleSelectionOtherErrorDescription')
      }
    },
    ctaButtonText () {
      switch (this.errorType) {
        case 'allocate':
          return this.$t('allocateAvailablelicenses')
        default:
          return this.$t('multipleSelectionErrorModalButtonText', {
            action: this.$t(this.errorType)
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';

  .error-title {
    color: $danger;
    font-size: 26px;
    font-weight: 400;
  }

  .error-description {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ErrorModal.vue